// =============================================
// Utilitários de autenticação do Conferente
// Arquivo separado para evitar dependência circular com api.ts
// =============================================

const CONFERENTE_TOKEN_KEY = 'conferente_token';
const CONFERENTE_USER_KEY = 'conferente_user';
const CONFERENTE_SESSAO_KEY = 'conferente_sessao_id';
const CONFERENTE_CNPJ_SLUG_KEY = 'conferente_cnpj_slug';

/**
 * Decodifica o payload de um JWT sem dependências externas.
 */
function decodeJwtPayload(token: string): { exp?: number; [key: string]: unknown } | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1].replace(/-/g, '+').replace(/_/g, '/');
    return JSON.parse(atob(payload));
  } catch {
    return null;
  }
}

/**
 * Retorna o token do conferente do localStorage.
 */
export function getConferenteToken(): string | null {
  return localStorage.getItem(CONFERENTE_TOKEN_KEY);
}

/**
 * Verifica se o token do conferente está expirado.
 */
export function isConferenteTokenExpired(): boolean {
  const token = getConferenteToken();
  if (!token) return true;
  const payload = decodeJwtPayload(token);
  if (!payload || !payload.exp) return true;
  return Date.now() >= (payload.exp * 1000) - 30000;
}

/**
 * Limpa os dados de sessão do conferente e redireciona para a página de login.
 * Usa guard para evitar múltiplos redirects simultâneos (race condition).
 */
let _isRedirecting = false;

export function handleConferenteSessionExpired(): void {
  if (_isRedirecting) return;
  _isRedirecting = true;

  localStorage.removeItem(CONFERENTE_TOKEN_KEY);
  localStorage.removeItem(CONFERENTE_USER_KEY);
  localStorage.removeItem(CONFERENTE_SESSAO_KEY);
  const cnpj = localStorage.getItem(CONFERENTE_CNPJ_SLUG_KEY);
  window.location.href = cnpj ? `/conferente/${cnpj}` : '/conferente/login';
}
